module.exports = __webpack_public_path__ + "src/app/_content/MOTFonts/BMWMotorradW01-Light.eot?88fec81bfa98a8413a5c4c68251abb11";